import type { DojoBeat, DojoLearnerMark } from '@/types/dojo';

/** Keep the learner's evidence next to the explanation they are writing. */
export function SelectedPassages({ marks, beat }: { marks: DojoLearnerMark[]; beat: DojoBeat }) {
  const kind = beat === 'react_well' ? 'admirable' : beat === 'react_better' ? 'adequate' : null;
  const passages = marks.filter(mark => mark.kind === kind && mark.quote.trim());
  if (!passages.length) return null;
  return (
    <section aria-label="Passages you chose" className="mx-auto mb-3 max-w-2xl">
      <p className="mb-2 text-xs font-medium text-how-text-secondary">Passages you chose</p>
      <div className="max-h-28 space-y-2 overflow-y-auto">
        {passages.map(mark => (
          <blockquote key={mark.id} className="border-l-2 border-how-accent-warm/50 pl-3 text-sm leading-5 text-how-space-deep/80">
            {mark.quote}
          </blockquote>
        ))}
      </div>
    </section>
  );
}
